import { Col } from "reactstrap";
import { H5 } from "../../../../AbstractElements";
import { BorderWidthTitle } from "../../../../Constants/Constants";
import { dynamicNumber } from "../../../../Utils";

const BorderWidth = () => {
  return (
    <Col xxl="3" sm="6">
      <div className="border-wrapper h-100 alert-light-light dark-helper">
        <H5 className="mb-3">{BorderWidthTitle}</H5>
        {dynamicNumber(10).map((item, index) => (
          <div className="helper-common-box" key={index}>
            <div className={`helper-box border border-${item}`} />
            <span>{`border-${item}`}</span>
          </div>
        ))}
      </div>
    </Col>
  );
};
export default BorderWidth;
